var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment';
import BundleModel from '@/models/BundleModel';
import CartOptionChoiceModel from '@/models/CartOptionChoiceModel';
import CartOptionModel from '@/models/CartOptionModel';
import OptionModel from '@/models/OptionModel';
import RecentOrderItem from '@/models/RecentOrderItem';
import RecentItemModel from '@/models/RecentItemModel';
import { service } from './app.service';
import { map, cloneDeep, forEach, concat } from 'lodash';
import { MENU_ITEMS, MENU_OPTIONS, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import store from '@/stores';
import RecentOrderModel from '@/models/RecentOrderModel';
import MasterOptionExceptionModel from '@/models/MasterOptionExceptionModel';
var recentOrderService = {
    createRecentItemHash: function (item) {
        var hash = item.franchisor_asset_id || item.id;
        if (item.comments) {
            hash += item.comments;
        }
        if (item.options) {
            hash += JSON.stringify(item.options);
        }
        if (item.sibling_options) {
            hash += item.sibling_options;
        }
        return hash;
    },
    getCurrentChoiceOptions: function (storeOption, choiceId) {
        if (storeOption && choiceId) {
            for (var _i = 0, _a = storeOption.choices; _i < _a.length; _i++) {
                var choice = _a[_i];
                if (choice.id === choiceId) {
                    return choice;
                }
            }
        }
        else {
            return false;
        }
    },
    createRecentScriptChoiceMap: function (option, storeOption, createModel) {
        if (createModel === void 0) { createModel = false; }
        var choiceMap = {};
        var createOptionChoiceModel = function (rawData, currentChoice) {
            return {
                description: currentChoice.description || null,
                fractionalQuantity: currentChoice.fractionalQuantity || null,
                id: currentChoice.id || rawData.choice_id || null,
                maxFractionalQuantity: currentChoice.maxFractionalQuantity || rawData.max_fractional_qty || null,
                maxQuantity: currentChoice.maxQuantity || null,
                mutableQuantity: currentChoice.mutableQuantity || null,
                name: currentChoice.name || null,
                parentId: currentChoice.parentId || null,
                quantity: rawData.qty,
                priceDelta: currentChoice.priceDelta || rawData.price_delta || null,
                selected: rawData.selected,
                isUserSet: rawData.is_user_set,
                includedQuantity: rawData.included_qty,
                required: currentChoice.required
            };
        };
        for (var _i = 0, _a = option.choices; _i < _a.length; _i++) {
            var choice = _a[_i];
            var rawData = __assign({}, choice, { qty: parseInt(choice.qty) });
            var currentChoice = this.getCurrentChoiceOptions(storeOption, choice.choice_id);
            // choice doesn't exist, throw away item
            if (!currentChoice) {
                return false;
            }
            else {
                if (!choiceMap[choice.choice_id]) {
                    choiceMap[choice.choice_id] = __assign({ raw: rawData }, (createModel && {
                        model: new CartOptionChoiceModel(createOptionChoiceModel(rawData, currentChoice))
                    }));
                }
                else {
                    // a version of this choice has greater qty, map that choice
                    var choiceQty = parseInt(choice.qty);
                    if (choiceMap[choice.choice_id].qty < choiceQty) {
                        choiceMap[choice.choice_id] = __assign({ raw: rawData }, (createModel && {
                            model: new CartOptionChoiceModel(createOptionChoiceModel(rawData, currentChoice))
                        }));
                    }
                }
            }
        }
        return choiceMap;
    },
    createOptionsChoicesMap: function (options, includeModels) {
        if (includeModels === void 0) { includeModels = false; }
        var optionMap = {};
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            var storeOption = store.getters[MENU_OPTIONS.GET_OPTION](option.option_id);
            optionMap[option.option_id] = __assign({ option: __assign({ raw: option }, (includeModels && { model: new CartOptionModel(new OptionModel(option)) })) }, (option.choices && {
                choiceMap: this.createRecentScriptChoiceMap(option, storeOption, includeModels)
            }));
            // throw away item
            if (option.choices && !optionMap[option.option_id].choiceMap) {
                return false;
            }
        }
        return optionMap;
    },
    convertRecentScriptToOrders: function (recentOrders, callback) {
        var _this = this;
        var recentOrderModels = [];
        if (recentOrders && recentOrders.length) {
            var _loop_1 = function (recentScript) {
                try {
                    var recentItemMap_1 = {};
                    var discardOrderFlag_1 = false;
                    // initiate recent order model
                    var recentOrderModel = new RecentOrderModel(__assign({}, recentScript, { items: [] }));
                    forEach(recentScript.items, function (item, index) {
                        var hash = _this.createRecentItemHash(item);
                        // increment quantity
                        if (recentItemMap_1[hash] && !item.bundle) {
                            recentItemMap_1[hash].quantity++;
                        }
                        else {
                            // get menu item from store
                            var menuItem = item.franchisor_asset_id
                                ? store.getters[MENU_ITEMS.GET_BY_PARENT_ASSET_ID](item.franchisor_asset_id)
                                : store.getters[MENU_ITEMS.GET_ITEM](item.asset_id);
                            // menu item doesn't exist, can't recreate
                            if (!menuItem) {
                                discardOrderFlag_1 = true;
                                return;
                            }
                            var assetId = item.asset_id;
                            var franchisorId = item.franchisor_asset_id;
                            var recentOrderItem = _this.getMenuItem(assetId, franchisorId);
                            recentOrderItem = new RecentOrderItem(__assign({}, recentOrderItem, { hydrationStrategy: 'recentScriptHydrator' }));
                            recentOrderItem.quantity = +item.quantity || 1;
                            if (item.bundle) {
                                var recentBundle = recentOrderService.handleBundleRecentOrders(item);
                                recentOrderItem.bundle = recentBundle.restoredBundle;
                                recentOrderItem.discounts = recentBundle.discounts;
                                recentOrderItem.quantity = 1;
                                // Only add if we have a bundle
                                if (recentOrderItem.bundle) {
                                    // update hash to use index, no 1+ quantity for bundles
                                    hash += "-" + index;
                                    recentItemMap_1[hash] = recentOrderItem;
                                }
                                return;
                            }
                            var recentItemModel = new RecentItemModel(item);
                            if (!recentItemModel.id) {
                                return;
                            }
                            recentItemMap_1[hash] = recentOrderService.handleItem(recentItemModel);
                            recentItemMap_1[hash].quantity = recentOrderItem.quantity || 1;
                            return;
                        }
                    });
                    if (!discardOrderFlag_1) {
                        //  add all items to this current recentOrderModel
                        for (var hash in recentItemMap_1) {
                            recentOrderModel.items.push(recentItemMap_1[hash]);
                        }
                        if (recentOrderModel.items.length && recentOrderModel.getCurrentRecentOrderValue()) {
                            recentOrderModel.itemsOutOfStock = recentOrderService.checkForItemsOutOfStock(recentOrderModel.items);
                            recentOrderModels.push(recentOrderModel);
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                    // Not doing anything if the recent order fail
                }
            };
            for (var _i = 0, recentOrders_1 = recentOrders; _i < recentOrders_1.length; _i++) {
                var recentScript = recentOrders_1[_i];
                _loop_1(recentScript);
            }
        }
        callback(recentOrderModels);
    },
    checkForItemsOutOfStock: function (cartItems) {
        for (var _i = 0, cartItems_1 = cartItems; _i < cartItems_1.length; _i++) {
            var item = cartItems_1[_i];
            var assetId = item.id;
            var menuItem = recentOrderService.getMenuItem(assetId, null);
            if (menuItem.outOfStock) {
                return true;
            }
        }
        return false;
    },
    getMenuItem: function (assetId, franchisorId) {
        var itemGetter = store.getters[MENU_ITEMS.GET_ITEM];
        var item = itemGetter(assetId);
        if (!item) {
            item = itemGetter(franchisorId);
        }
        var itemCopy = cloneDeep(item);
        return itemCopy;
    },
    getMenuItemOptions: function (item) {
        var options = store.getters[MENU_OPTIONS.GET_ITEM_ALL](item);
        var optionsCopy = cloneDeep(options);
        return optionsCopy;
    },
    getMenuItemOptionException: function (itemId) {
        var optionException = store.getters[MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM](itemId);
        var optionExceptionCopy = cloneDeep(optionException);
        return optionExceptionCopy;
    },
    handleBundleRecentOrders: function (item) {
        var _this = this;
        var assetId = item.asset_id;
        var franchisorId = item.franchisor_asset_id;
        var menuItem = recentOrderService.getMenuItem(assetId, franchisorId);
        item['hydrationStrategy'] = 'recentScriptHydrator';
        var bundleItem = new RecentOrderItem(item);
        bundleItem.restoreFromItem(menuItem);
        var discounts = bundleItem.discounts;
        var restoredBundle = bundleItem.bundle;
        var itemsInBundle = restoredBundle.items;
        var optionExceptions = {};
        // create mapping of option exceptions by item asset ID from bundle group
        if (menuItem.bundle.groups[0]) {
            menuItem.bundle.groups[0].options.forEach(function (option) {
                optionExceptions[option.asset_id] = option.option_exception;
            });
        }
        var invalidBundle = false;
        restoredBundle.items = map(itemsInBundle, function (item) {
            var individualItemOptionException = cloneDeep(_this.getMenuItemOptionException(item.id));
            if (!individualItemOptionException) {
                invalidBundle = true;
                return;
            }
            // masterOption from bundle group for a Menu item should take precedence over an individual's item option exception
            if (optionExceptions[item.id]) {
                individualItemOptionException.masterOption = new MasterOptionExceptionModel(optionExceptions[item.id]);
            }
            return recentOrderService.handleItem(item, individualItemOptionException);
        });
        // Knock out the bundle, the calling code will filter it out
        if (invalidBundle) {
            restoredBundle = null;
        }
        return { restoredBundle: restoredBundle, discounts: discounts };
    },
    handleItem: function (item, menuItemOptionExceptions) {
        if (menuItemOptionExceptions === void 0) { menuItemOptionExceptions = null; }
        var assetId = item.id || item.asset_id;
        if (!assetId) {
            var originalItem = store.getters[MENU_ITEMS.GET_ITEM](item.franchisor_asset_id);
            assetId = originalItem.id;
        }
        if (!assetId) {
            return null;
        }
        var franchisorId = item.parentAssetId || item.franchisor_asset_id;
        var menuItem = recentOrderService.getMenuItem(assetId, franchisorId);
        if (!menuItem) {
            return null;
        }
        var menuItemOptions = recentOrderService.getMenuItemOptions(menuItem);
        menuItemOptionExceptions = menuItemOptionExceptions || recentOrderService.getMenuItemOptionException(menuItem.id);
        if (!(item instanceof RecentItemModel)) {
            item['asset_id'] = assetId;
            item = new RecentItemModel(item);
        }
        var restoredItem = item.restore(menuItem, menuItemOptions, menuItemOptionExceptions);
        restoredItem.setGroupId(item.parentGroupId);
        return restoredItem;
    },
    handleFractionalChoice: function (cartOptionChoice) {
        if (cartOptionChoice.quantity === 0) {
            cartOptionChoice.setQuantity(cartOptionChoice.getFractionalQuantity());
            cartOptionChoice.mutableQuantity = true;
        }
    },
    convertSingleItem: function (lineItem) {
        var _this = this;
        var cartItemOptionModels = null;
        if (lineItem.options) {
            cartItemOptionModels = lineItem.options.map(function (option) {
                var cartOptionChoiceModels = option.choices
                    ? option.choices.map(function (choice) {
                        var cartOptionChoice = new CartOptionChoiceModel(__assign({}, choice, { id: JSON.stringify(choice), mutableQuantity: true }));
                        if (cartOptionChoice.quantity === 0) {
                            _this.handleFractionalChoice(cartOptionChoice);
                        }
                        return cartOptionChoice;
                    })
                    : null;
                return new CartOptionModel(__assign({}, option, { choices: cartOptionChoiceModels }));
            });
        }
        return new RecentOrderItem(__assign({}, lineItem, { options: cartItemOptionModels, id: lineItem.lineitem_id }));
    },
    convertSingleItemWithSiblings: function (lineItem, lineItems) {
        var _this = this;
        var masterOptions = {};
        var recentOrderItem = new RecentOrderItem(__assign({}, lineItem, { options: [], id: lineItem.lineitem_id }));
        var _loop_2 = function (sibId) {
            // each option
            lineItems[sibId].options.forEach(function (option) {
                // found optionModel, add choices here
                if (masterOptions[option.id]) {
                    if (option.choices) {
                        // if we find a choice, its going to be on the whole item
                        // else one side
                        option.choices.forEach(function (choice) {
                            // search the model
                            var foundChoice = masterOptions[option.id].getExistingChoice(__assign({}, choice, { id: JSON.stringify(choice) }));
                            if (foundChoice === null) {
                                var cartOptionChoice = new CartOptionChoiceModel(__assign({}, choice, { siblingId: (lineItems[sibId].sibling_ids.indexOf(sibId) + 1).toString(), id: JSON.stringify(choice) }));
                                if (cartOptionChoice.quantity === 0) {
                                    _this.handleFractionalChoice(cartOptionChoice);
                                }
                                masterOptions[option.id].choices.push(cartOptionChoice);
                            }
                            else {
                                // on both sides
                                foundChoice.setSibling('0');
                            }
                        });
                    }
                }
                else if (!masterOptions[option.id]) {
                    // add choices to new option
                    var cartOptionChoiceModels = option.choices
                        ? option.choices.map(function (choice) {
                            var cartOptionChoice = new CartOptionChoiceModel(__assign({}, choice, { siblingId: (lineItems[sibId].sibling_ids.indexOf(sibId) + 1).toString(), id: JSON.stringify(choice) }));
                            if (cartOptionChoice.quantity === 0) {
                                _this.handleFractionalChoice(cartOptionChoice);
                            }
                            return cartOptionChoice;
                        })
                        : null;
                    var optionModel = new CartOptionModel(__assign({}, option, { choices: cartOptionChoiceModels }));
                    masterOptions[option.id] = optionModel;
                }
            });
        };
        for (var _i = 0, _a = lineItems[lineItem.lineitem_id].sibling_ids; _i < _a.length; _i++) {
            var sibId = _a[_i];
            _loop_2(sibId);
        }
        for (var id in masterOptions) {
            recentOrderItem.addOption(masterOptions[id]);
        }
        return recentOrderItem;
    },
    convertSingleOrder: function (order, timeZone) {
        var _this = this;
        if (timeZone === void 0) { timeZone = null; }
        var recentOrderModel = new RecentOrderModel({
            id: order.order_id || order.order ? order.order.order_id : null,
            bill_amount: order.order.bill_amount,
            closed_date: moment.unix(order.order.closed_date).toDate(),
            cr_date: moment.unix(order.order.cr_date).toDate(),
            purchase_date: order.order.purchase_date || order.order.cr_date,
            promise_date: moment.unix(order.order.promise_date).toDate(),
            delivery_details: order.order.delivery_details,
            items: [],
            location_base: order.order.location_base,
            order_notes: order.order.order_notes,
            service_type: order.order.service_type,
            status: this.getRecentOrderStatus(order.order.items),
            totals: order.api_order.totals,
            pickup_delay: order.order.pickup_delay
        });
        var lineItems = {};
        var handledIds = {};
        var itemHashMap = {};
        // map lineitem id to obj
        order.api_order.lineItems.forEach(function (lineItem) {
            lineItems[lineItem.lineitem_id] = lineItem;
        });
        var _loop_3 = function (id) {
            var recentOrderItem;
            // lineItem hasn't been handled
            if (!handledIds[id]) {
                // single item
                if (!lineItems[id].bundle_id && !lineItems[id].bundled_ids && !lineItems[id].sibling_ids) {
                    recentOrderItem = this_1.convertSingleItem(lineItems[id]);
                    handledIds[id] = true;
                }
                else if (!lineItems[id].bundle_id && !lineItems[id].bundled_ids && lineItems[id].sibling_ids) {
                    recentOrderItem = this_1.convertSingleItemWithSiblings(lineItems[id], lineItems);
                    // mark all handled ids
                    lineItems[id].sibling_ids.forEach(function (sibId) {
                        handledIds[sibId] = true;
                    });
                }
                else if (lineItems[id].bundled_ids) {
                    // create top level cartItemModel
                    recentOrderItem = new RecentOrderItem(lineItems[id]);
                    recentOrderItem.bundle = new BundleModel({
                        name: lineItems[id].name,
                        id: lineItems[id].lineitem_id
                    });
                    recentOrderItem.bundle.items = [];
                    handledIds[id] = true;
                    lineItems[id].bundled_ids.forEach(function (index) {
                        var bundledItem;
                        // bundled item without siblings
                        if (!lineItems[index].sibling_ids) {
                            bundledItem = _this.convertSingleItem(lineItems[index]);
                            handledIds[index] = true;
                            bundledItem.inBundle = true;
                            recentOrderItem.bundle.items.push(bundledItem);
                        }
                        else if (lineItems[index].sibling_ids) {
                            // bundled items with sides
                            bundledItem = _this.convertSingleItemWithSiblings(lineItems[index], lineItems);
                            bundledItem.inBundle = true;
                            lineItems[index].sibling_ids.forEach(function (sibId) {
                                handledIds[sibId] = true;
                            });
                            recentOrderItem.bundle.items.push(bundledItem);
                        }
                    });
                }
                var recentItemHash = this_1.createRecentItemHash(lineItems[id]);
                if (itemHashMap[recentItemHash]) {
                    if (!itemHashMap[recentItemHash].quantity) {
                        itemHashMap[recentItemHash].quantity = 1;
                    }
                    else {
                        itemHashMap[recentItemHash].quantity++;
                        itemHashMap[recentItemHash].price += recentOrderItem.price;
                        var discounts = itemHashMap[recentItemHash].discounts;
                        itemHashMap[recentItemHash].discounts = concat(discounts, recentOrderItem.discounts);
                    }
                }
                else if (recentOrderItem) {
                    itemHashMap[recentItemHash] = recentOrderItem;
                    recentOrderModel.items.push(recentOrderItem);
                }
            }
        };
        var this_1 = this;
        for (var id in lineItems) {
            _loop_3(id);
        }
        return recentOrderModel;
    },
    getLiveOrders: function (lb) {
        var ht = '6b2de090-c2cc-11e4-88c0-000a9d100df8';
        return service.get("admin/squib_load_display_board?lb=" + lb + "&ht=" + ht);
    },
    getRecentOrderStatus: function (items) {
        var maxStatus = 0;
        for (var key in items) {
            if (maxStatus < items[key].status) {
                maxStatus = items[key].status;
            }
        }
        return maxStatus;
    },
    getRecentOrders: function (customerId, lb, count) {
        if (count === void 0) { count = 10; }
        return service.get('/admin/squib_recent_orders', {
            params: {
                customer: customerId,
                lb: lb,
                a: 1,
                c: 10
            }
        });
    }
};
export default recentOrderService;



//////////////////
// WEBPACK FOOTER
// ./src/services/recent.orders.service.ts
// module id = o0YE
// module chunks = 18